import { CONTRACT_SERVICE } from "@/store/constants";

const SCHEDULES = '/schedules'

export default {
  namespaced: true,
  actions: {
    getSchedules ({ dispatch }, { id }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(SCHEDULES + '/' + encodeURIComponent(target)))
        .then(result => (result.data.items))
    },
    getSchedule ({ dispatch }, { target, id }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(SCHEDULES + '/' + encodeURIComponent(target) + '/' + encodeURIComponent(id)))
        .then(result => (result.data))
    },
    saveSchedule ({ dispatch }, { target, data }) {
      const id = data.id
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => {
          if (id) {
            return api.put(SCHEDULES + '/' + encodeURIComponent(target) + '/' + encodeURIComponent(id), data)
          } else {
            return api.post(SCHEDULES + '/' + encodeURIComponent(target), data)
          }
        })
        .then(result => (result.data))
    },
    deleteSchedule ({ dispatch }, { target, id }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.delete(SCHEDULES + '/' + encodeURIComponent(target) + '/' + encodeURIComponent(id)))
        .then(result => (result.data))
    },
  },
  getters: {},
  mutations: {},
  state: {}
}
